//#region src/canary_tier.ts
var CanaryTier = /* @__PURE__ */ function(CanaryTier) {
	CanaryTier[CanaryTier["Tier1"] = 1] = "Tier1";
	CanaryTier[CanaryTier["Tier2"] = 2] = "Tier2";
	CanaryTier[CanaryTier["Tier3"] = 3] = "Tier3";
	return CanaryTier;
}(CanaryTier || {});
//#endregion
export { CanaryTier };

//# sourceMappingURL=canary_tier.js.map